import { Theme } from '@support/models/theme.model';

export const themes: Theme[] = [
  {
    name: 'ice-default-theme',
    label: 'Light theme',
    phone_illustration: 'assets/images/phone_illustration.jpg',
    mbb_illustration: 'assets/images/mbb_illustration.jpg',
    accessories_illustration: 'assets/images/accessories_illustration.svg',
    thumbs_up_illustration: 'assets/images/thumbs_up_illustration.svg',
    praise_illustration: 'assets/images/praise_illustration.svg',
    checkmark_illustration: 'assets/images/checkmark_illustration.svg',
    cogs_illustration: 'assets/images/cogs_illustration.svg',
    box_illustration: 'assets/images/box_illustration.svg',
    phone_slanted_illustration: 'assets/images/phone_slanted_illustration.svg',
    eSim_illustration: 'assets/images/e-sim_illustration.svg',
    smartwatch_illustration: 'assets/images/smartwatch_illustration.svg',
    mobilpant_illustration: 'assets/images/mobilpant_illustration.svg',
  },
  {
    name: 'ice-dark-theme',
    label: 'Dark theme',
    phone_illustration: 'assets/images/phone_illustration_dark.png',
    mbb_illustration: 'assets/images/mbb_illustration_dark.png',
    accessories_illustration: 'assets/images/accessories_illustration_dark.svg',
    thumbs_up_illustration: 'assets/images/thumbs_up_illustration_dark.svg',
    praise_illustration: 'assets/images/praise_illustration_dark.svg',
    checkmark_illustration: 'assets/images/checkmark_illustration_dark.svg',
    cogs_illustration: 'assets/images/cogs_illustration_dark.svg',
    box_illustration: 'assets/images/box_illustration_dark.svg',
    phone_slanted_illustration: 'assets/images/phone_slanted_illustration_dark.svg',
    eSim_illustration: 'assets/images/e-sim_illustration_dark.svg',
    smartwatch_illustration: 'assets/images/smartwatch_illustration_dark.svg',
    mobilpant_illustration: 'assets/images/mobilpant_illustration_dark.svg',
  },
];

export const [INITIAL_THEME] = themes;

export const dialogWidth = '33rem';
export const dialogWidthLarge = '40rem';
export const dialogWidthSmall = '29.5rem';

// TODO: mbb and accessories illustration should have a light and dark version of the images
export const imageAssets = {
  phone_illustration: 'assets/images/phone_illustration.jpg',
  mbb_illustration: 'assets/images/mbb_illustration.jpg',
  accessories_illustration: 'assets/images/accessories_illustration.svg',
  checkmark_illustration: 'assets/images/checkmark_illustration.svg',
  cogs_illustration: 'assets/images/cogs_illustration.svg',
  box_illustration: 'assets/images/box_illustration.svg',
  phone_slanted_illustration: 'assets/images/phone_slanted_illustration.svg',
  logo: 'assets/images/ice-logo.svg#logo',
  imei: 'assets/images/IMEI.png',
  gtin: 'assets/images/EAN-GTIN.png',
  ice_trygg: 'assets/images/ice_trygg.png',
};
